// services/postJob.js
import { DRAFT_END_URL } from '../constants/all';
import { STEP_WISE_KEYS_IN_POST_JOB } from '../constants/advertiser';
import { getFormattedBody, findSubmitData } from '../utils/functions';
import { getMethod, postMethod }      from '../utils/api';
import { COMMON_ENDPOINTS } from '@/api/commonServices';
import { isAndroid } from '@/android/bridge';

/* ------------------------------------------------------------------ *
   All helpers already inherit BASE_URL = NEXT_PUBLIC_BASE_URL_ADS
   from utils/api, so only pass the path segment.
 * ------------------------------------------------------------------ */

/** Fetch the draft-context block that powers the form wizard. */
export const fetchDraftContext = ({
  params           = {},
  language         = 'en',
  isAndroidWebview = false,
  withStatusCode   = true          // full Axios response needed
} = {}) =>
  getMethod({
    url   : DRAFT_END_URL,         // '/submissions/submissions/draft_context/'
    params,
    headers: { 'Accept-Language': language },
    withStatusCode,
    isAndroidWebview
  });

/** Fetch a single submission when the user resumes an existing draft. */
export const fetchSubmission = ({
  submissionId,
  params           = {},
  language         = 'en',
  isAndroidWebview = false,
  withStatusCode   = true
}) =>
  getMethod({
    url: `/submissions/v4/submissions/${submissionId}`,
    params,
    headers: { 'Accept-Language': language },
    withStatusCode,
    isAndroidWebview
  });

  export const draftPost = async ({
  step,
  formData,
  locale = 'en',
  isEnterprise = false
}) => {
  /* ---------- build query-params ---------- */
  const locObj   = JSON.parse(localStorage.getItem('location') || '{}');
  const params   = { location: locObj?.id, en: 0, locale };

  /* ---------- build formatted body ---------- */
  const raw      = JSON.parse(JSON.stringify(formData || {}));
  const payload  = findSubmitData(raw);          // keys flattened + mapped
  payload.platform  = 'web';
  payload['page-no'] = step;

  /* ---------- network call (JWT helper) ----- */
  return postMethod({
    url   : DRAFT_END_URL,      // helper already sets the baseURL
    params,
    headers: { 'App-Type': 'web' },
    data  : getFormattedBody({
      data : payload,
      step,
      keys : STEP_WISE_KEYS_IN_POST_JOB,
      isEnterprise
    }),
    isAndroidWebview: isAndroid()
  });
};

export async function fetchAdvertiserCourses(qualificationId, headers) {
 return getMethod({
   url: `${COMMON_ENDPOINTS.QUALIFICATION_COURSES}`,
   params: { qualification_id: qualificationId },
   headers,
   withStatusCode: true,
   isAndroidWebview: isAndroid(),
 })
}

export async function fetchAdvertiserSearch({ q = '', qualificationId = null, pageNum = 1 }, headers = {}) {
 return getMethod({
   url: `${COMMON_ENDPOINTS.QUALIFICATION_SEARCH}`,
   params: {
     text: q,
     qualification_id: qualificationId,
     page: pageNum
   },
   headers,
   withStatusCode: true,
   isAndroidWebview: isAndroid()
 })
}

export async function fetchAdvertiserCertificates(courseId, headers, signal = null) {
 return getMethod({
   url: `${COMMON_ENDPOINTS.QUALIFICATION_CERTIFICATES}`,
   params: { course_id: courseId },
   headers,
   withStatusCode: true,
   isAndroidWebview: isAndroid(),
   signal
 })
}

